<template>
  <div class="team-members__empty text-center q-my-lg">
    <q-icon name="o_groups" size="32px" color="grey-6" class="team-members__empty-icon" />
    <p class="team-members__empty-title">No other team members</p>
    <p class="team-members__empty-subtitle">Invite team members to collaborate</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState'
};
</script>

<style lang="scss" scoped>
@import './team-members-styles.scss';
</style>
